export function isLightHexColor(hex: string): boolean {
  const parsed = hex.replace("#", "").trim();
  if (parsed.length !== 6) return false;

  const r = Number.parseInt(parsed.slice(0, 2), 16) / 255;
  const g = Number.parseInt(parsed.slice(2, 4), 16) / 255;
  const b = Number.parseInt(parsed.slice(4, 6), 16) / 255;
  if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return false;

  const channel = (c: number) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
  const luminance = 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
  return luminance > 0.5;
}
